var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Form', {
    attrs: {
      "adaptive-on900": "",
      "data-e2e": "payment"
    }
  }, [_c('FormElement', {
    attrs: {
      "title": "Тип оплаты:"
    }
  }, [_c('OrderTypeSelect', {
    attrs: {
      "list": _vm.list,
      "value": _vm.value,
      "name": "payment-type"
    },
    on: {
      "change": function ($event) {
        return _vm.onChange($event.id);
      }
    }
  }), _vm._v(" "), _vm.current && _vm.current.description ? _c('div', {
    staticClass: "mt-20 p",
    domProps: {
      "innerHTML": _vm._s(_vm.current.description)
    }
  }) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }